import React, { ReactNode } from "react";
import { useRouter } from "next/navigation";
import truncateText from "@/utils/truncateText";

interface DefaultProps {
  heading: string;
  publishDate: string;
  link?: string;
}

const ArticlePill = ({ heading, publishDate, link }: DefaultProps) => {
  const router = useRouter();

  const date = new Date(publishDate);

  const formatter = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <a href={link} target="_new" className="group">
      <div className="bg-putty-400 p-2 rounded-xl border border-solid h-[100px] group-hover:text-white group-hover:bg-secondary-500 no-underline group-hover:no-underline">
        <span className="font-bold mb-2 w-full block">
          {truncateText(heading, 75)}
        </span>
        {date && (
          <div className="text-primary-300  group-hover:text-white group-hover:bg-secondary-500">
            {formatter.format(date)}
          </div>
        )}
      </div>
    </a>
  );
};

export default ArticlePill;
